import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Section, SectionHeader } from './Shared';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section id="preguntas" tone="cream" innerClassName="max-w-3xl" data-id="element-56" data-mp="1cf9ka81chzg0">
      <SectionHeader title="Lo que más nos preguntan" data-id="element-57" data-mp="2a28kgsr8xpin" />
      <div className="mt-10 space-y-3" data-id="element-58" data-mp="2a0xf4oi5k9pf">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        const buttonId = `faq-button-${index}`;
        const panelId = `faq-panel-${index}`;
        return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-59" data-mp="2065lfvroy6zx" data-mpi={index}>
              <h3 className="font-sans" data-id="element-60" data-mp="1v4q002llpyh0">
                <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-mint/40 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-brand-violet md:px-6" data-id="element-61" data-mp="oonll7d8drio">
                  <span className="text-base font-bold text-brand-violet md:text-lg" data-id="element-62" data-mp="1aq2c9uu02m4f">{faq.q}</span>
                  <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-brand-orangeDark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-63" data-mp="1fo4351xo3pqg" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-64" data-mp="16oqv8dp6z97u">
                {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-65" data-mp="rzb4uytkp5so">
                    <p className="border-t border-brand-violet/10 px-5 py-4 text-base leading-relaxed text-brand-ink/85 md:px-6" data-id="element-66" data-mp="2pn55d5e9qwdv">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}